module.exports = __webpack_public_path__ + "7f5df6d6469a3af2f2bc6fe19f625cdb.pdf";